import utils from "../../utils/utils"

function formataMetas(metas) {
    metas = [...metas]
    metas.forEach((meta, index) => {
        let ano = meta.metasMensais.mes.map((mes, i) => {
            return {
                mes: mes,
                numTurmas: meta.metasMensais["numTurmas"][i],
                numAlunosTurmas: meta.metasMensais["numAlunosTurmas"][i],
                cargaHoraria: meta.metasMensais["cargaHoraria"][i],
                numMatriculasResiduais: meta.metasMensais["numMatriculasResiduais"][i],
                numMatriculasNovas: meta.metasMensais["numMatriculasNovas"][i],
                numTotalMatriculas: meta.metasMensais["numTotalMatriculas"][i],
                horaAluno: meta.metasMensais["horaAluno"][i],
                cargaHorariaTurmaAno: meta.metasMensais["cargaHorariaTurmaAno"][i],
                necessidadeDocente8H: meta.metasMensais["necessidadeDocente8H"][i],
                necessidadeDocente7H: meta.metasMensais["necessidadeDocente7H"][i]
            }
        });
        metas[index].metasMensais = ano;
    });
    return metas;
}

function calculaDados(data) {

    let meses = ["janeiro", "fevereiro", "marco", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];
    let mesesSIgla = ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"];
    let tipoFinanciamento = ["Pago", "Gratuidade Regimental", "Gratuidade Não-Regimental"]

    let tudo = {}

    meses.map((mes, unidadeIndice) => {

        let mesArr = []

        let porUnidade = groupBy(data, "unidade");

        Object.keys(porUnidade).map((unidade, i) => {
            if (unidade === "") return;
            let novoObj = {}
            novoObj["unidade"] = unidade;
            novoObj["modalidades"] = {}
            let porModalidade = groupBy(porUnidade[unidade], "modalidade");

            Object.keys(porModalidade).map((modalidade, j) => {

                let objModalidades = {
                    matricula_regimental: 0,
                    matricula_nao_regimental: 0,
                    matricula_pago: 0,
                    hora_regimental: 0,
                    hora_nao_regimental: 0,
                    hora_pago: 0
                }


                let pago = porModalidade[modalidade].filter((filter) => filter.tipo === "Pago");
                let regimental = porModalidade[modalidade].filter((filter) => filter.tipo === "Gratuidade Regimental");
                let nao_regimental = porModalidade[modalidade].filter((filter) => filter.tipo === "Gratuidade Não-Regimental");

                if (pago.length > 0) {
                    objModalidades["matricula_pago"] = pago.reduce((acc, atual) => atual["metasMensais"][unidadeIndice]["numTotalMatriculas"] + acc, 0);
                    objModalidades["hora_pago"] = pago.reduce((acc, atual) => atual["metasMensais"][unidadeIndice]["horaAluno"] + acc, 0);
                }

                if (regimental.length > 0) {
                    objModalidades["matricula_regimental"] = regimental.reduce((acc, atual) => {
                        if (atual["metasMensais"][unidadeIndice]) return atual["metasMensais"][unidadeIndice]["numTotalMatriculas"] + acc
                    }, 0);
                    objModalidades["hora_regimental"] = regimental.reduce((acc, atual) => {
                        if (atual["metasMensais"][unidadeIndice]) return atual["metasMensais"][unidadeIndice]["horaAluno"] + acc
                    }, 0);
                }

                if (nao_regimental.length > 0) {
                    objModalidades["matricula_nao_regimental"] = nao_regimental.reduce((acc, atual) => atual["metasMensais"][unidadeIndice]["numTotalMatriculas"] + acc, 0);
                    objModalidades["hora_nao_regimental"] = nao_regimental.reduce((acc, atual) => atual["metasMensais"][unidadeIndice]["horaAluno"] + acc, 0);
                }

                novoObj["modalidades"][modalidade] = objModalidades

            })
            mesArr.push(novoObj)
        })

        tudo[mes] = mesArr
    });

    return tudo

}

function calculaTotalDR(dados) {

    if(dados) {

        Object.keys(dados).map(mes => {

            let dr = {
                unidade: "DR",
                modalidades: {}
            };

            (dados[mes] || []).map((unidade) => {

                Object.keys(unidade.modalidades).map((modalidade) => {

                    let valorModalidade = unidade.modalidades[modalidade];

                    if(!dr.modalidades.hasOwnProperty(modalidade)) {
                        dr.modalidades[modalidade] = { ...valorModalidade };
                    }
                    else {
                        Object.keys(valorModalidade).map((valor) => {
                            dr.modalidades[modalidade][valor] += valorModalidade[valor]
                        });
                    }

                });

            });

            dados[mes].push(dr);

        });
    }

    return dados;

}

function groupBy (objectArray, property) {
    return objectArray.reduce(function (acc, obj) {
        var key = obj[property];
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
    }, {});
}

function novoJsonMetas(metas, realizados) {

    let unidades = [];
    let novo = []

    metas = { ...metas }

    Object.keys(metas).map((mes, mesInd) => {

        Object.keys(metas[mes]).map(unidade => {

            let unidadeFormatada = utils.getUnidadeRealizado(metas[mes][unidade].unidade);
            let modalidades = [];

            if(unidades.includes(unidadeFormatada)) {

                Object.keys(metas[mes][unidade]["modalidades"]).map(modalidade => {

                    Object.keys(metas[mes][unidade]["modalidades"][modalidade]).map(attr => {

                        if(novo[unidades.indexOf(unidadeFormatada)]["metas"][modalidade][attr]) {
                            novo[unidades.indexOf(unidadeFormatada)]["metas"][modalidade][attr][mesInd] += metas[mes][unidade]["modalidades"][modalidade][attr]
                        }

                    });

                });

            }

            else {

                let objeto = {
                    unidade: unidadeFormatada,
                    metas: {}
                }

                Object.keys(metas[mes][unidade]["modalidades"]).map(modalidade => {

                    let modalidadeFormatada = utils.getModalidades(modalidade);

                    if(modalidades.includes(modalidadeFormatada)) {

                    }
                    else {

                        let novoObj = {}

                        Object.keys(metas[mes][unidade]["modalidades"][modalidade]).map(attr => {
                            let arr = new Array(12).fill(0);
                            arr[mesInd] = metas[mes][unidade]["modalidades"][modalidade][attr] || 0;
                            novoObj[attr] = arr
                        });

                        objeto.metas[modalidade] = novoObj
                        modalidades.push(modalidadeFormatada);

                    }
                });

                unidades.push(unidadeFormatada);
                novo.push(objeto)
            }

        });

    })

    return novo

}

function usarMedida(entry) {
    return Object.keys(entry).reduce((obj, key) => {
        const value = entry[key];
        obj[utils.getModalidades(key)] = value;
        return obj;
    }, {});
}

function calculaAcumuladoMetas2(dados) {

    let meses = ["janeiro", "fevereiro", "marco", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];
    let acumulado = { };

    meses.map((mes, i) => {
        dados = JSON.parse(JSON.stringify(dados));
        let sliceMeses = meses.slice(0, i + 1);
        let mesSelecionado = sliceMeses[sliceMeses.length-1];
        let metaAcumulado = calculaAcumuladoMetas3(dados, mesSelecionado, sliceMeses);
        acumulado = { ...acumulado, ...metaAcumulado }
    });
    return acumulado;

}

function calculaAcumuladoMetas3(dados, mesSelecionado, sliceMeses){

    dados = JSON.parse(JSON.stringify(dados));

    let meses = sliceMeses;

    let acumulado = { };
    acumulado[mesSelecionado] = [];

    if(dados.hasOwnProperty(mesSelecionado)) {

        meses.map((mes, i) => {

            dados[mes].map((unidade, j) => {

                let ind = acumulado[mesSelecionado].findIndex(uni => uni.unidade === unidade.unidade);

                if(ind < 0) {
                    acumulado[mesSelecionado].push(unidade);
                }

                else {
                    Object.keys(unidade.modalidades).map(modalidade => {

                        Object.keys(unidade.modalidades[modalidade]).map(valor => {
                            acumulado[mesSelecionado][ind]["modalidades"][modalidade][valor] += unidade.modalidades[modalidade][valor]
                        });

                    });
                }

            });
        });

    }

    return acumulado;
}

function novoJsonRealizados(metas) {

    let unidades = [];
    let novo = []

    metas = JSON.parse(JSON.stringify(metas));

    // ========== Ordenar JSON por meses ==========
    let meses = ["janeiro", "fevereiro", "marco", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];
    metas = meses.reduce((acc, atual) => {
        if(metas[atual]) acc[atual] = metas[atual]
        return acc
    }, {});
    // ============================================

    Object.keys(metas).map((mes, mesInd) => {

        Object.keys(metas[mes]).map(unidade => {

            let modalidades = [];

            if(unidades.includes(metas[mes][unidade].unidade)) {

                Object.keys(metas[mes][unidade]["modalidades"]).map(modalidade => {

                    Object.keys(metas[mes][unidade]["modalidades"][modalidade]).map(attr => {
                        if(novo[unidades.indexOf(metas[mes][unidade].unidade)]["metas"][modalidade]) {
                            try {
                                novo[unidades.indexOf(metas[mes][unidade].unidade)]["metas"][modalidade][attr][mesInd] += metas[mes][unidade]["modalidades"][modalidade][attr]
                            } catch(erro) {
                            }
                        }
                        /*
                        if(novo[unidades.indexOf(metas[mes][unidade].unidade)]["metas"][modalidade][attr]) {
                            novo[unidades.indexOf(metas[mes][unidade].unidade)]["metas"][modalidade][attr][mesInd] += metas[mes][unidade]["modalidades"][modalidade][attr]
                        }
                        */

                    });


                });

            }

            else {

                let objeto = {
                    unidade: metas[mes][unidade].unidade,
                    metas: {}
                }

                Object.keys(metas[mes][unidade]["modalidades"]).map(modalidade => {

                    if(modalidades.includes(modalidade)) {

                    }
                    else {

                        let novoObj = {}
                        Object.keys(metas[mes][unidade]["modalidades"][modalidade]).map(attr => {
                            let arr = new Array(12).fill(0);
                            arr[mesInd] = metas[mes][unidade]["modalidades"][modalidade][attr] || 0;
                            novoObj[attr] = arr
                        });

                        objeto.metas[modalidade] = novoObj
                        modalidades.push(modalidade);

                    }
                });

                unidades.push(metas[mes][unidade].unidade);
                novo.push(objeto)
            }

        });

    })

    return novo

}

function todasAsModalidades(dados) {
    dados = JSON.parse(JSON.stringify(dados))
    try {

        let todasAsModalidades = {};

        for(let modalidade in dados) {

            Object.keys(dados[modalidade]).map(valores => {

                if(todasAsModalidades.hasOwnProperty(valores)) {

                    todasAsModalidades[valores].forEach((v, i) => {
                        todasAsModalidades[valores][i] += dados[modalidade][valores][i];
                    });

                }
                else {
                    todasAsModalidades[valores] = dados[modalidade][valores];
                }

            });

        }

        return todasAsModalidades;

    } catch (error) {
        //return new Array(12).fill(0);
    }

}

export default {
    formataMetas,
    calculaDados,
    calculaTotalDR,
    novoJsonMetas,
    usarMedida,
    calculaAcumuladoMetas2,
    novoJsonRealizados,
    todasAsModalidades
}
